module.exports = __webpack_public_path__ + "static/foto-fero-1757f9cc4b03e386c0bb74e9c8804d8e.png";